import {useEffect} from 'react';

// basically same as useEffect, but per default it just runs on mount
// if deps are passed its the same as useEffect
export const useMount = (effect, deps = []) => useEffect(effect, [...deps]);
